// 下載中心 API，對齊 backend/domain/staff/repository/export_order/types.go（同舊版 pages/tasks/exportOrders.js）
import { request } from '@/lib/request'

// 下載中心不分頁：一次抓足量、以捲動瀏覽
const PAGE_SIZE = 100

export const getExportOrders = ({ signal } = {}) => request.get('/api/v1/export-orders', { params: { page: 1, page_size: PAGE_SIZE }, signal })

export const cancelExportOrder = (orderNo) => request.put(`/api/v1/export-orders/${orderNo}/cancel`)

// fire-and-forget：只記錄「使用者在下載中心按了下載」，不擋下載、不 toast；
// skipAuthHandling：401 時不整頁重載，避免打斷下載（PSD-381，同舊版刻意不經 res2json）
export const recordExportDownload = (orderNo) => request.post(`/api/v1/export-orders/${encodeURIComponent(orderNo)}/download`, undefined, { skipAuthHandling: true })
